"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePath = exports.createPath = exports.createMemoryHistory = exports.createHashHistory = exports.createBrowserHistory = exports.Action = void 0;
var Action;
(function (Action) {
    Action["Pop"] = "POP";
    Action["Push"] = "PUSH";
    Action["Replace"] = "REPLACE";
})(Action = exports.Action || (exports.Action = {}));
var readOnly = function (obj) { return Object.freeze(obj); };
function warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined")
            console.warn(message);
        try {
            throw new Error(message);
        }
        catch (e) { }
    }
}
var BeforeUnloadEventType = "beforeunload";
var HashChangeEventType = "hashchange";
var PopStateEventType = "popstate";
function createBrowserHistory(options) {
    if (options === void 0) { options = {}; }
    var _a = options.window, window = _a === void 0 ? document.defaultView : _a;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _a = window.location, pathname = _a.pathname, search = _a.search, hash = _a.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        }
        else {
            var nextAction = Action.Pop;
            var _a = getIndexAndLocation(), nextIndex = _a[0], nextLocation = _a[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta_1 = index - nextIndex;
                    if (delta_1) {
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function () {
                                go(delta_1 * -1);
                            }
                        };
                        go(delta_1);
                    }
                }
                else {
                    warning(false, "You are trying to block a POP navigation to a location that was not " +
                        "created by the history library. The block will fail silently in " +
                        "production, but in general you should do all navigation with the " +
                        "history library (instead of using window.history.pushState directly) " +
                        "to avoid this situation.");
                }
            }
            else {
                applyTx(nextAction);
            }
        }
    }
    window.addEventListener(PopStateEventType, handlePop);
    var action = Action.Pop;
    var _b = getIndexAndLocation(), index = _b[0], location = _b[1];
    var listeners = createEvents();
    var blockers = createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState(__assign(__assign({}, globalHistory.state), { idx: index }), "");
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) { state = null; }
        return readOnly(__assign(__assign(__assign({}, location), (typeof to === "string" ? parsePath(to) : to)), { state: state, key: createKey() }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({ action: action, location: location, retry: retry }), false);
    }
    function applyTx(nextAction) {
        var _a;
        action = nextAction;
        _a = getIndexAndLocation(), index = _a[0], location = _a[1];
        listeners.call({ action: action, location: location });
    }
    function push(to, state) {
        var nextAction = Action.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _a = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _a[0], url = _a[1];
            try {
                globalHistory.pushState(historyState, "", url);
            }
            catch (error) {
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = Action.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _a = getHistoryStateAndUrl(nextLocation, index), historyState = _a[0], url = _a[1];
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action() {
            return action;
        },
        get location() {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function () {
            go(-1);
        },
        forward: function () {
            go(1);
        },
        listen: function (listener) {
            return listeners.push(listener);
        },
        block: function (blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) {
                window.addEventListener(BeforeUnloadEventType, promptBeforeUnload);
            }
            return function () {
                unblock();
                if (!blockers.length) {
                    window.removeEventListener(BeforeUnloadEventType, promptBeforeUnload);
                }
            };
        }
    };
    return history;
}
exports.createBrowserHistory = createBrowserHistory;
function createHashHistory(options) {
    if (options === void 0) { options = {}; }
    var _a = options.window, window = _a === void 0 ? document.defaultView : _a;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _a = parsePath(window.location.hash.substr(1)), _b = _a.pathname, pathname = _b === void 0 ? "/" : _b, _c = _a.search, search = _c === void 0 ? "" : _c, _d = _a.hash, hash = _d === void 0 ? "" : _d;
        var state = globalHistory.state || {};
        return [
            state.idx,
            readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        }
        else {
            var nextAction = Action.Pop;
            var _a = getIndexAndLocation(), nextIndex = _a[0], nextLocation = _a[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta_2 = index - nextIndex;
                    if (delta_2) {
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function () {
                                go(delta_2 * -1);
                            }
                        };
                        go(delta_2);
                    }
                }
                else {
                    warning(false, "You are trying to block a POP navigation to a location that was not " +
                        "created by the history library. The block will fail silently in " +
                        "production, but in general you should do all navigation with the " +
                        "history library (instead of using window.history.pushState directly) " +
                        "to avoid this situation.");
                }
            }
            else {
                applyTx(nextAction);
            }
        }
    }
    window.addEventListener(PopStateEventType, handlePop);
    window.addEventListener(HashChangeEventType, function () {
        var _a = getIndexAndLocation(), nextLocation = _a[1];
        if (createPath(nextLocation) !== createPath(location)) {
            handlePop();
        }
    });
    var action = Action.Pop;
    var _b = getIndexAndLocation(), index = _b[0], location = _b[1];
    var listeners = createEvents();
    var blockers = createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState(__assign(__assign({}, globalHistory.state), { idx: index }), "");
    }
    function getBaseHref() {
        var base = document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) { state = null; }
        return readOnly(__assign(__assign(__assign({}, location), (typeof to === "string" ? parsePath(to) : to)), { state: state, key: createKey() }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({ action: action, location: location, retry: retry }), false);
    }
    function applyTx(nextAction) {
        var _a;
        action = nextAction;
        _a = getIndexAndLocation(), index = _a[0], location = _a[1];
        listeners.call({ action: action, location: location });
    }
    function push(to, state) {
        var nextAction = Action.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        warning(nextLocation.pathname.charAt(0) === "/", "Relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            var _a = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _a[0], url = _a[1];
            try {
                globalHistory.pushState(historyState, "", url);
            }
            catch (error) {
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = Action.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        warning(nextLocation.pathname.charAt(0) === "/", "Relative pathnames are not supported in hash history.replace(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            var _a = getHistoryStateAndUrl(nextLocation, index), historyState = _a[0], url = _a[1];
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action() {
            return action;
        },
        get location() {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function () {
            go(-1);
        },
        forward: function () {
            go(1);
        },
        listen: function (listener) {
            return listeners.push(listener);
        },
        block: function (blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) {
                window.addEventListener(BeforeUnloadEventType, promptBeforeUnload);
            }
            return function () {
                unblock();
                if (!blockers.length) {
                    window.removeEventListener(BeforeUnloadEventType, promptBeforeUnload);
                }
            };
        }
    };
    return history;
}
exports.createHashHistory = createHashHistory;
function createMemoryHistory(options) {
    if (options === void 0) { options = {}; }
    var _a = options.initialEntries, initialEntries = _a === void 0 ? ["/"] : _a, initialIndex = options.initialIndex;
    var entries = initialEntries.map(function (entry) {
        var location = readOnly(__assign({ pathname: "/", search: "", hash: "", state: null, key: createKey() }, (typeof entry === "string" ? parsePath(entry) : entry)));
        warning(location.pathname.charAt(0) === "/", "Relative pathnames are not supported in createMemoryHistory({ initialEntries }) (invalid entry: " + JSON.stringify(entry) + ")");
        return location;
    });
    var index = clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = Action.Pop;
    var location = entries[index];
    var listeners = createEvents();
    var blockers = createEvents();
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) { state = null; }
        return readOnly(__assign(__assign(__assign({}, location), (typeof to === "string" ? parsePath(to) : to)), { state: state, key: createKey() }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({ action: action, location: location, retry: retry }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({ action: action, location: location });
    }
    function push(to, state) {
        var nextAction = Action.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        warning(location.pathname.charAt(0) === "/", "Relative pathnames are not supported in memory history.push(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = Action.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        warning(location.pathname.charAt(0) === "/", "Relative pathnames are not supported in memory history.replace(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = clamp(index + delta, 0, entries.length - 1);
        var nextAction = Action.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index() {
            return index;
        },
        get action() {
            return action;
        },
        get location() {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function () {
            go(-1);
        },
        forward: function () {
            go(1);
        },
        listen: function (listener) {
            return listeners.push(listener);
        },
        block: function (blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
}
exports.createMemoryHistory = createMemoryHistory;
function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function promptBeforeUnload(event) {
    event.preventDefault();
    event.returnValue = "";
}
function createEvents() {
    var handlers = [];
    return {
        get length() {
            return handlers.length;
        },
        push: function (fn) {
            handlers.push(fn);
            return function () {
                handlers = handlers.filter(function (handler) { return handler !== fn; });
            };
        },
        call: function (arg) {
            handlers.forEach(function (fn) { return fn && fn(arg); });
        }
    };
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
function createPath(_a) {
    var _b = _a.pathname, pathname = _b === void 0 ? "/" : _b, _c = _a.search, search = _c === void 0 ? "" : _c, _d = _a.hash, hash = _d === void 0 ? "" : _d;
    return pathname + search + hash;
}
exports.createPath = createPath;
function parsePath(path) {
    var partialPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            partialPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            partialPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) {
            partialPath.pathname = path;
        }
    }
    return partialPath;
}
exports.parsePath = parsePath;
